import { useMemo } from 'react'
import { fetcher } from '@/utils/fetcher'
import useSwr from 'swr'
import { API_URL } from '@/utils/constants'

export default function useTokenPrices() {
	const { data, isLoading } = useSwr(`${API_URL}/tokens/prices`, fetcher)
	const { data: globalData } = useSwr(`https://prices.ordinalswallet.com`, fetcher)

	const prices = useMemo(() => {
		if (!globalData) {
			return []
		}

		let globalPrices = Object.keys(globalData).map((e) => {
			let price = globalData[e]
			if (Array.isArray(data)) {
				let found = data.find((d) => d.slug === e)
				if (found) {
					price = Math.min(price, parseFloat(found.floor_price_per))
				}
			}

			return {
				slug: e,
				floor_price_per: price,
				icon: ''
			}
		})

		if (Array.isArray(data)) {
			const owOnlyPrices = data.filter((e) => !globalData[e.slug])
			return globalPrices.concat(owOnlyPrices)
		}

		return globalPrices
	}, [globalData, data])

	if (Array.isArray(data)) {
		return { data: prices, isLoading }
	}

	return { data: prices, isLoading }
}
